import React from 'react';
import cn from 'classnames';
import { CollapseEl, Icon } from '@landing/ui';

import * as styles from './Item.module.scss';

export default function Item({ id, title, description, theme, onClick, isOpened }) {
  return (
    <section id={id} className={cn(styles.wrapper, theme && styles[theme])}>
      <button className={cn(styles.panel, isOpened && styles.active)} onClick={onClick}>
        <p className={styles.title}>{title}</p>
        <Icon className={styles.arrowIcon} name="arrow" />
      </button>
      <CollapseEl toggle={isOpened} className={styles.panelContentWrapper}>
        <p className={styles.description}>{description}</p>
      </CollapseEl>
    </section>
  );
}
